import { combineReducers } from 'redux'
import { connectRouter } from 'connected-react-router'
import { userReducer } from './user/reducer'
import { sessionReducer } from './session/reducer'
import { history } from '../utils/history'
import { themeReducer } from './theme/reducer'
import { hookReducer } from './hook/reducer'
import { profileReducer } from './profile/reducer'
import { paymentTemplateReducer } from './paymentTemplate/reducer'
import { statReducer } from './stats/reducer'
import { userChatReducer } from './userchat/reducer'
import { menuReducer } from './menu/reducer'
import { flowReducer } from './flow/reducer'

export const rootReducer = combineReducers({
  user: userReducer,
  menu: menuReducer,
  session: sessionReducer,
  themes: themeReducer,
  hooks: hookReducer,
  flows: flowReducer,
  profiles: profileReducer,
  paymentTemplates: paymentTemplateReducer,
  stats: statReducer,
  userChats: userChatReducer,
  router: connectRouter(history)
})
